document.querySelectorAll('.na-faq-item').forEach(function (item) {
  var q = item.querySelector('.na-faq-q');
  var a = item.querySelector('.na-faq-a');

  q.addEventListener('click', function () {
    var isOpen = item.classList.contains('na-is-open');

    document.querySelectorAll('.na-faq-item.na-is-open').forEach(function (openItem) {
      if (openItem !== item) {
        openItem.classList.remove('na-is-open');
        openItem.querySelector('.na-faq-a').style.maxHeight = null;
      }
    });

    if (isOpen) {
      item.classList.remove('na-is-open');
      a.style.maxHeight = null;
    } else {
      item.classList.add('na-is-open');
      a.style.maxHeight = a.scrollHeight + 'px';
    }
  });
});
